import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'TS',
    name: 'The Timeless',
    id: 'TheTimeless',
    health: 60,
    difficulty: 7,
    expeditionRating: 3,
	fightFiveAdditionalInfo: `
	<p>During setup, swap one of the nemesis turn order cards for the Unleash turn order card.</p>
	<p>Play using Increased Difficulty.</p>
	`,
    additionalInfo: '',
  },
]
